module.exports = __webpack_public_path__ + "img/rascrut-11.c4ad3bce.jpg";